module.exports = __webpack_public_path__ + "img/cover.3a20a217.jpg";